export const DAILY_POOL = 'Daily Pool';
export const PRE_LAUNCH_POOL = 'Pre-launch Pool';
export const ALL_TERM = 'All';
